import { useState } from 'react';
import _get from 'lodash/get';

import { EMPTY_ARRAY } from '../constants';
import useDeepCompareEffect from './useDeepCompareEffect';

const useDependencies = (currentProps: any) => {
	const { getDependencies, name, dependencyResolver, watch } = currentProps;

	let dependencies = _get(currentProps, 'dependencies', EMPTY_ARRAY);
	dependencies = getDependencies ? getDependencies(name) : dependencies;

	const [propChanges, setPropChanges] = useState<any>();
	const dependencyValues = watch(dependencies);

	useDeepCompareEffect(() => {
		if (dependencies && dependencies.length > 0) {
			setPropChanges(dependencyResolver(currentProps, dependencyValues));
		}
	}, [dependencyValues]);

	if (propChanges) {
		return { ...currentProps, ...propChanges };
	}
	return currentProps;
};

export default useDependencies;
